export const Button = ({children}) => {
  return (
    <button className="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 w-64 text-xl rounded-lg px-5 py-2.5 mr-2 mb-2 font-medium">{children}</button>
  )
}
